export const THEMES = ['light', 'sky', 'pearl', 'brown-white', 'brown', 'dark', 'midnight', 'rose'] as const;
export type AppTheme = (typeof THEMES)[number];
export type AppLanguage = 'al' | 'en' | 'it';
export const APP_LANGUAGES: Array<{ value: AppLanguage; country: string; label: string }> = [
  { value: 'al', country: 'AL', label: 'Shqip' },
  { value: 'en', country: 'GB', label: 'English' },
  { value: 'it', country: 'IT', label: 'Italiano' },
];
export const themeSwatches: Record<AppTheme, string> = {
  light: 'linear-gradient(135deg,#fff 50%,#2563eb 50%)',
  sky: 'linear-gradient(135deg,#eaf5ff 50%,#4f9cf9 50%)',
  pearl: 'linear-gradient(135deg,#fbfbff 50%,#7c3aed 50%)',
  'brown-white': 'linear-gradient(135deg,#f8f3ed 50%,#8b5e3c 50%)',
  brown: 'linear-gradient(135deg,#281e18 50%,#d69a68 50%)',
  dark: 'linear-gradient(135deg,#0f1a2e 50%,#60a5fa 50%)',
  midnight: 'linear-gradient(135deg,#151124 50%,#a78bfa 50%)',
  rose: 'linear-gradient(135deg,#fff 50%,#b03a62 50%)',
};
export const isTheme = (value: unknown): value is AppTheme => THEMES.includes(value as AppTheme);
export const normalizeLanguage = (value: unknown): AppLanguage | null => {
  if (typeof value !== 'string') return null;
  const language = value.toLowerCase().split('-')[0];
  if (language === 'sq') return 'al';
  return language === 'al' || language === 'en' || language === 'it' ? language : null;
};
export const isDarkTheme = (theme: AppTheme) => ['brown', 'dark', 'midnight'].includes(theme);
